module.exports = __webpack_public_path__ + "img/video-bg-md.8b0dd337.jpg";